<template>
    <div class="release">
        <main>
            <el-form label-width="120px" class="form" :model="formParams" :rules="rules" ref="formParams">
                <el-form-item label="训练类型" prop="publishType" class="formitem">
                    <el-radio-group v-model="formParams.publishType" style="margin: 10px 0 0 10px;">
                        <el-radio :label="0">考核训练</el-radio>
                        <el-radio :label="1">任务训练</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-divider class="divider"></el-divider>
                <el-form-item label="训练主题" prop="publishSubject">
                    <el-input v-model="formParams.publishSubject" style="margin: 10px 0 10px 10px;width: auto;"  maxlength="30" show-word-limit></el-input>
                </el-form-item>

                <el-divider class="divider"></el-divider>
                <el-form-item label="选择对象">
                    <div class="chooseobject">
                        <div class="item">
                          <el-cascader 
                          ref="wcascader" 
                          @change="Selected_to_shut_dow" 
                          @expand-change="bumen"
                          v-model="DeptID" 
                          :options="DeprtMentByNodeData" 
                          :props="{ checkStrictly: true }" clearable>
                            </el-cascader>
                            <!-- <el-button type="primary" round style="margin:0 0 0 10px;background: #3C65F5;border:none;width: 96px;">选择部门</el-button> -->
                        </div>
                        <div class="item">
                            <el-input style="margin:10px 10px 0 0;width: auto;" v-model="UserParams.name" placeholder="请输入账号或姓名"></el-input>
                            <el-button type="primary" round style="background: #FFE45E;color: #000;border:none;width: 96px;" @click="queryuser">查询</el-button>
                        </div>
                    </div>
                    <p class="choosetitle">用户列表</p>
                    <div class="userlist">
                        <el-button type="primary" class="items" v-for="item in UserList" style="cursor: default;">{{item.RealName}}<i class="el-icon-plus addicon" @click="AddUser(item)"></i></el-button>
                    </div>
                </el-form-item>

                <el-divider class="divider"></el-divider>
                <el-form-item label="所选对象">
                  <div style="margin: 0 0 10px 10px;">
                    分组编号：<el-input style="margin:10px 10px 0 0;width: auto;" v-model="groupNum" placeholder="请输入分组编号" maxlength="2" ></el-input>
                  </div>
                  <div class="userlist">
                    <div type="primary" 
                    class="items" 
                    v-for="(item,index) in formParams.publishUsers" 
                    @dragstart="dragstart(index)"
                    @dragenter="dragenter($event, index)"
                    @dragover="dragover($event, index)"
                    :key="item.userID"
                    draggable="true" 
                    >{{item.realName}}<i class="el-icon-minus addicon" @click="clickminus(item,index)"></i></div>
                  </div>
                </el-form-item>
                
                <el-divider class="divider"></el-divider>
                <el-form-item label="选择训练素材">
                  <div v-for="(item,index) in ColumnManagementByNode" :key="item.value" >
                    <div class="tree_label"> 
                          <label @click="ClickTree(item,index)">{{item.label}}</label>
                        <span class="el-icon-plus addicon" @click="Addsourcematerial(item)" v-if="item.MaterialList.length>0"></span>
                    </div>

                      <div class="children" v-show="item.MaterialList.length>0">
                        <div class="tree_label" v-for="items in item.MaterialList" :key="items.materialKey">
                          {{items.materialName}} 
                          <span class="el-icon-plus addicon" @click="Addsourcematerial(items)"></span>
                      </div>
                      </div>
                  </div>
                </el-form-item>

                <el-divider class="divider"></el-divider>
                <el-form-item label="所选素材(可拖拽调整顺序)">
                  <div class="userlist">
                    <div type="primary" 
                    class="items" 
                    v-for="(item,index) in formParams.publishTrainmaterials" 
                    @dragstart="dragstart(index)"
                    @dragenter="materialdragenter($event, index)"
                    @dragover="dragover($event, index)"
                    :key="item.trainID"
                    draggable="true" 
                    >{{item.materialName}}<i class="el-icon-minus addicon" @click="clickmaterial(item,index)"></i></div>
                  </div>
                </el-form-item>

                <el-divider class="divider"></el-divider>
                <el-form-item label="是否启用">
                    <el-switch v-model="formParams.isActive" style="margin: 18px 10px;" :active-value="1" :inactive-value="0"></el-switch>
                </el-form-item>

                <el-divider class="divider"></el-divider>
                <el-form-item label="训练描述">
                    <el-input v-model="formParams.remark" type="textarea" maxlength="500" show-word-limit></el-input>
                </el-form-item>

            </el-form>
            <div class="btn">
              <el-button @click="$router.go(-1)">取消</el-button>
              <el-button type="primary" v-if="publishID" @click="submit()">修改</el-button>
              <el-button type="primary" v-else @click="submit()">提交</el-button>
            </div>
        </main>
    </div>
</template>
<script>
export default{
    name:'release',
    data() {
        return {
          rules:{
            publishSubject:[{required: true,message: '请输入培训主题', trigger: 'blur' }],
            publishType:[{required: true,message: '请选择培训主题', trigger: 'change' }],
          },
          publishID:this.$route.query.publishID,
          DeptID:[],
          groupNum:1,
          formParams:{
            publishSubject:'',//训练主题
            moduleID:'2',//模块标识:1-MusicRelax 音乐放松 2-生物反馈 BiofeedBack 3-团体对抗TTDKXL
            lineNumber:'',
            isActive:1,//是否启用
            runState:'',//运行状态(默认给0):0-未开始 1-已开始 2-已结束
            publishType:'',//发布类型
            trainIDs:[],//训练素材主键（id、key）
            publishUsers:[],
            publishTrainmaterials:[],
            remark:''
          },
          UserList:[],
          UserIDs:[],
          UserParams:{
            deptID:'', // 部门;
            pageSize:10,
            pageIndex:1,
            roleID:sessionStorage.getItem('RoleID'),
            name:'',
          },
          sourcematerialparams:{
            PItemKey: "0",
            RoleID:sessionStorage.getItem('RoleID'),
            Type: 1,
            pageIndex: "1",
            pageSize: "111110"
          },
          paramsMaterial:{
            ItemKey:'',
            MaterialName:'',
            PageIndex:1,
            PageSize:10
          },
          MaterialList:[],
          DeprtMentByNodeData:[],
          ColumnManagementByNode:[],
          // 源对象的下标
          dragIndex: '',
          // 目标对象的下标
          enterIndex: '',
        }
    },
    mounted() {
        this.GetDeprtMentByNode();
        this.getColumnManagement();
        if(this.$route.query.publishID){
          this.publish();
        }
    },
    methods: {

      // 回显
      publish(){
        this.$Http_Get('/bioassay/publish/'+this.$route.query.publishID).then(res=>{
          if(res.Code==0){
            this.formParams.isActive=res.Data.isActive;
            this.formParams.publishSubject=res.Data.publishSubject;
            this.formParams.publishType=res.Data.publishType;
            this.formParams.remark=res.Data.remark;
            this.formParams.publishTrainmaterials=res.Data.publishTrainmaterials;
            // this.formParams.publishUsers=res.Data.publishUsers;
          }else{
            this.$message.error(res.Message);
          }
          console.log(res)
        })
      },
      // 获取训练素材
      getColumnManagement(){
        this.$Http_Post('/management/getColumnManagementByNode',this.sourcematerialparams).then(res=>{
          if(res.Code==0 || res.Code==200){
            for(let item of res.Data){
              item['MaterialList']=[];
              this.ColumnManagementByNode.push(item);
            }
          }
        })
      },
      // 获取对象
      GetDeprtMentByNode(){
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: '', content: '' }).then((res) => {
            if (res.Data) { this.DeprtMentByNodeData = res.Data; }
        })
      },
      // 
      ClickTree(e,index){
        if(e.MaterialList.length>0){
          this.ColumnManagementByNode[index]['MaterialList']=[];
          return;
        }
        this.paramsMaterial.ItemKey=e.value;
        this.$Http_Post('/management/getMaterialList',this.paramsMaterial).then(res=>{
          if(res.Code==0 || res.Code==200){
              if(res.Data.length>0){
                this.ColumnManagementByNode[index]['MaterialList']=res.Data;
              }
          }
        });
      },
      // 添加素材
      Addsourcematerial(e){
        let sortIndex=this.formParams.publishTrainmaterials.length;
        if(e.ItemLevel){
          for(let item of e.MaterialList){
            if(!this.formParams.trainIDs.includes(item.materialName)){
              this.formParams.trainIDs.push(item.materialName.toString());
              this.formParams.publishTrainmaterials.push({trainID:item.materialKey,sortIndex:sortIndex,materialName:item.materialName});
            }
          }
        }else{
          if(this.formParams.trainIDs.includes(e.materialName)){
            this.$message.warning("请勿重复添加");
            return false;
          }
          this.formParams.trainIDs.push(e.materialName);
          this.formParams.publishTrainmaterials.push({trainID:e.materialKey,sortIndex:sortIndex,materialName:e.materialName});
        }
      },

      // 查询对象
      queryuser(){
        if(this.DeptID){
          this.UserParams.deptID=this.DeptID[this.DeptID.length - 1];
        };
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$Http_Post('/User/throughConditionGetUserList',this.UserParams).then(res=>{
          if(res.Code==0 || res.Code==200){
            this.UserList=res.Data;
            loading.close();
          }
        })
      },

      Selected_to_shut_dow(dt){
        this.formParams.DeptID = dt[dt.length - 1]
        this.$refs.wcascader.dropDownVisible = false
      },
      bumen(dt){
        let obj = this.DeprtMentByNodeData[0];
        for (let i = 0; i < this.DeprtMentByNodeData.length; i++) {
          if (this.DeprtMentByNodeData[i].DeptID == dt[dt.length - 1]) {
            obj = this.DeprtMentByNodeData[i];
            break
          } else if (this.DeprtMentByNodeData[i].fuzi && this.DeprtMentByNodeData[i].children.length > 0 && this.DeprtMentByNodeData[i].children[0].DeptID != '-1') {
            obj = this.GetNodeByDeptID(
              dt[dt.length - 1],
              this.DeprtMentByNodeData[i].children,
            )
          }
        }
        let _this = this;
        if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
          obj.children = [{ label: '数据加载中...' }]
          this.$Http_Post('/DepartMent/getalldepartmentbynode', {DeptID: dt[dt.length - 1],content: '',}).then((res) => {
            if (res.Code == 200 || res.Code == 0 && res.Data) {
              obj.children = res.Data;
            }
          })
        }
      },

      GetNodeByDeptID(ID, NodeList) {
      let obj = null;
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i];
          break
        } else if (NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children);
          if (obj != null) break;
        }
      }
      return obj;
    },
    
      dragstart(index) {
        this.dragIndex = index
      },
 
    // dragenter 和 dragover 事件的默认行为是拒绝接受任何被拖放的元素。 
    // 因此，我们要在这两个拖放事件中使用`preventDefault`来阻止浏览器的默认行为
    dragenter(e,index) { 
      e.preventDefault();
      this.enterIndex = index
      if(this.dragIndex !== index){
        const source = this.formParams.publishUsers[this.dragIndex]
        this.formParams.publishUsers.splice(this.dragIndex,1)
        this.formParams.publishUsers.splice(index, 0 , source )
        // 排序变化后目标对象的索引变成源对象的索引
        this.dragIndex = index;
      }
    },
    materialdragenter(e,index){
      e.preventDefault();
      this.enterIndex = index
      if(this.dragIndex !== index){
        const source = this.formParams.publishTrainmaterials[this.dragIndex]
        this.formParams.publishTrainmaterials.splice(this.dragIndex,1)
        this.formParams.publishTrainmaterials.splice(index, 0 , source);
        // 排序变化后目标对象的索引变成源对象的索引
        this.dragIndex = index;
      }
    },
    dragover(e, index) {
      e.preventDefault();
    },
    // 添加用户
    AddUser(e){
      let sortIndex=this.formParams.publishUsers.length;
      if(!this.UserIDs.includes(e.UserID)){
        this.UserIDs.push(e.UserID);
        this.formParams.publishUsers.push({
              userID:e.UserID,
              groupName:this.groupNum,
              sortIndex:sortIndex,
              realName:e.RealName+'_'+this.groupNum
          });
      }
      
    },
    // 删除用户
    clickminus(e){
      let index=this.UserIDs.indexOf(e.userID);
      this.formParams.publishUsers.splice(index,1)
      this.UserIDs.splice(index,1)
    },
    // 删除所选素材
    clickmaterial(e){
      let index=this.formParams.trainIDs.indexOf(e.materialName);
      this.formParams.trainIDs.splice(index,1)
      this.formParams.publishTrainmaterials.splice(index,1);
    },
    submit(){
      this.$refs['formParams'].validate((valid) => {
          if (valid) {
            for(let item in this.formParams.publishTrainmaterials){
              this.formParams.publishTrainmaterials[item].sortIndex=item;
            }
            this.$Http_Post('/bioassay/publish/add',this.formParams).then(res=>{
              if(res.Code==0 || res.Code==200){
                this.$message.success(res.Message);
              }else{
                this.$message.error(res.Message);
              }
            })
          }else{
            this.$message.error("请填写完整信息");
          }
        })
    }

    },
}
</script>
<style>
.release{background: #fff;border-radius: 8px;padding-bottom: 60px;padding: 20px 0;}
.release .form{background:#EBEFFE;}
.release .el-form-item{margin: 0;}
.release .el-form-item__content{border: 1px solid #A7B1DB;border-left:none;background: #fff;max-height: 400px;overflow: auto;}
.release .el-form-item__label{background: #EBEFFE;padding: 10px 10px 0;}
.release main{margin: 16px;}
.release .chooseobject{border-bottom: 1px solid #A7B1DB;padding:0 0 10px 10px;}
.release .chooseobject .item{display: inline-block;margin-right: 30px;}
.release .choosetitle{background: #EDEFF2;font-size: 14px;text-align: center;border-bottom:1px solid #A7B1DB;}
.release .divider{background: #fff;height: 16px;margin: 0;}
.release .userlist{display: flex;flex-wrap: wrap;padding:0 5px;}
.release .userlist .items{position: relative;margin: 5px;width: 168px;line-height:32px;background:#6379C7;color: #fff;border-radius: 4px;text-align: center;cursor: grab;}
.release .userlist .items:active{cursor: grabbing;}
.release .userlist .items .addicon{position: absolute;bottom: 5px;right:5px;border-radius: 50%;background: #fff;color: #6379C7;font-size: 10px;cursor: pointer;}
.release .el-textarea__inner{border: none;outline: none;}
.release .el-tree-node__content{height: auto;cursor: default}
.release .tree_label{background:#6379C7;color: #fff;border-radius: 4px;text-align: center;width: 168px;line-height:32px;margin: 5px;position: relative;cursor:default;}
.release .tree_label .addicon{position: absolute;bottom: 5px;right:5px;border-radius: 50%;background: #fff;color: #6379C7;font-size: 10px;cursor: pointer;}
.release .children{margin-left: 20px;}
.release .btn{padding: 30px 0;text-align: right;}
.release .el-form-item__error{top: 50%;left: 240px;margin-top: -12px;}
.release .formitem .el-form-item__content{line-height: 50px;}
</style>